<template>
  <div class="content-page mobile-app">
    <div class="mian-page">
      <div class="title-page"></div>
      <div class="backgroundBox">
        <div class="main-contentBox">
          <!-- 返回按钮 -->
          <div class="back-btn" @click="handleBack">
            <span class="back-text">‹返回</span>
          </div>

          <!-- 提示文字 -->
          <div class="tip-text">点击材料即可在线阅览：</div>

          <!-- 文件列表 -->
          <div class="file-list">
            <div
              v-for="(item, index) in fileList"
              :key="item.id || index"
              class="file-item"
              @click="handleFileClick(item, index)"
            >
              <span class="file-name">{{ item.name }}</span>
            </div>
            <div v-if="!fileList || fileList.length === 0" class="no-data">
              暂无文件
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@api/api";

export default {
  name: "ReviewList",
  data() {
    return {
      caseOrderNo: "",
      applicantName: "",
      filingTime: "",
      fileList: [],
    };
  },
  mounted() {
    const { caseOrderNo, applicantName, filingTime } = this.$route.query;
    this.caseOrderNo = caseOrderNo || "";
    this.applicantName = decodeURIComponent(applicantName || "");
    this.filingTime = decodeURIComponent(filingTime || "");

    // 加载文件列表
    if (this.caseOrderNo) {
      this.loadFileList();
    }
  },
  methods: {
    /**
     * 加载文件列表
     */
    async loadFileList() {
      try {
        this.$loading({
          lock: true,
          text: "加载中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        // 调用API获取文件列表
        const response = await Api.getReviewFileList(this.caseOrderNo);

        this.$loading().close();

        if (response.data && response.data.code == 0 && response.data.data) {
          // 转换文件列表格式，使用 showImgPathList 字段
          const fileList = (response.data.data || []).map((item, index) => {
            const fileName = item.fileName || item.name || `文件${index + 1}`;

            return {
              id: item.id || index + 1,
              name: fileName,
              fdfsUrl: item.fdfsUrl || '',
              path: item.path || item.filePath || item.url || item.showPath || '', // 保存文件路径，用于预览
              downloadPath: this.getDownloadPath(item)
            };
          });

          this.fileList = fileList;
        } else {
          this.$message.warning("暂无文件");
          this.fileList = [];
        }
      } catch (error) {
        this.$loading().close();
        console.error("加载文件列表失败", error);
        this.$message.error("加载文件列表失败");
        this.fileList = [];
      }
    },

    /**
     * 点击文件，打开预览
     */
    handleFileClick(item, index) {
      console.log(item);
      
      if (!item) {
        this.$message.warning("文件信息不存在");
        return;
      }

      const path = item.path || '';

      if (!path) {
        this.$message.warning("暂无预览文件");
        return;
      }

      const fileBaseUri = this.joinFileUrl(item.fdfsUrl, path);

      if (!fileBaseUri) {
        this.$message.warning("文件链接不存在");
        return;
      }

      // 判断文件类型
      const url = fileBaseUri.toLowerCase();
      let evidenceType = "";

      if (url.endsWith(".pdf")) {
        evidenceType = "pdf";
      } else if (
        url.endsWith(".png") ||
        url.endsWith(".jpg") ||
        url.endsWith(".jpeg") ||
        url.endsWith(".gif") ||
        url.endsWith(".bmp")
      ) {
        evidenceType = url.split(".").pop();
      } else if (url.endsWith(".txt")) {
        evidenceType = "txt";
      } else if (url.endsWith(".html") || url.endsWith(".htm")) {
        evidenceType = "html";
      } else if (url.endsWith(".mp4") || url.endsWith(".avi")) {
        evidenceType = url.split(".").pop();
      } else {
        // 默认尝试作为图片预览
        evidenceType = "jpg";
      }

      // 跳转到预览页面
      this.$router.push({
        name: "FilePreview",
        query: {
          evidencePath: encodeURIComponent(fileBaseUri),
          evidenceType: evidenceType,
          evidenceName: encodeURIComponent(item.name),
          applicantName: this.applicantName,
          filingTime: this.filingTime,
          downloadPath: encodeURIComponent(item.downloadPath || fileBaseUri),
          caseOrderNo: this.caseOrderNo,
          filePath: encodeURIComponent(item.path || ''),
        },
      });
    },

    joinFileUrl(baseUrl, filePath) {
      if (!filePath) return "";
      if (filePath.startsWith("http://") || filePath.startsWith("https://")) {
        return filePath;
      }
      if (!baseUrl) return filePath;
      return `${baseUrl.replace(/\/$/, "")}/${filePath.replace(/^\//, "")}`;
    },

    getDownloadPath(item) {
      if (!item) return "";
      const filePath = item.filePath || item.url || item.showPath || item.path || "";
      return this.joinFileUrl(item.fdfsUrl || "", filePath);
    },

    /**
     * 返回上一页
     */
    handleBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped lang="scss">
.mian-page {
  height: 100%;
  .backgroundBox {
    height: calc(100% - 100px);
    .main-contentBox {
      padding: 30px 20px 40px;
      width: 100%;
      height: 100%;

      .back-btn {
        margin-bottom: 20px;
        cursor: pointer;

        .back-text {
          font-size: 16px;
          color: #287AFD;
          font-weight: 500;
        }
      }

      .tip-text {
        font-size: 14px;
        color: #666;
        margin-bottom: 20px;
      }

       .file-list {
         width: 100%;
         height: calc(100% - 60px); // 减去返回按钮和提示文字的高度
         overflow-y: auto;
         overflow-x: hidden;

         .file-item {
          width: 100%;
          padding: 16px;
          background-color: #fff;
          border-radius: 8px;
          margin-bottom: 12px;
          cursor: pointer;
          transition: background-color 0.3s;

          &:active {
            background-color: #f5f5f5;
          }

          .file-name {
            font-size: 15px;
            color: #1c72fd;
            line-height: 1.5;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
          }
        }

        .no-data {
          text-align: center;
          padding: 40px 0;
          color: #999;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
